<div class="dasboard-width font-13">
  <div class="row header mar-lft-rgt-0">
    <div class="col-md-4">Create Document</div>
    <div class="col-md-4"> Organization -{{clientName}}</div>
    <div class="col-md-4">
      <ol class="breadcrumb cust-bread ">
        <li class="breadcrumb-item"><a class="pointer" (click)="changeRouting('dashboard')"><i
          class="fa fa-dashboard"></i> Home</a></li>
        <li class="breadcrumb-item active" aria-current="page">CreateTicket</li>
      </ol>
    </div>
  </div>
  <div class="content mr-top-5 ">

    <div class="row mar-lft-rgt-0">
      <div class="col-md-12 pad-15">
        <select class="custom-select  tcktyp" *ngFor="let ticket of ticketTypes;"
                (change)="onCategoryChange(ticket,$event.target.value)" id="ticket_{{ticket.id}}">
          <option *ngFor="let option of ticket.options" [value]="option|json">{{option.title}}</option>
        </select>
      </div>
    </div>

    <div class="row mar-lft-rgt-0">
      <div class="col-sm-12 form-group">
        <input type="text" class="form-control radius-0 font-13"
               placeholder="Document Title" [(ngModel)]="name">
      </div>

      <div class="col-sm-12 form-group">
          <textarea class="form-control radius-0 font-13 height-120"
                    placeholder="Put your document content,keyword etc." [(ngModel)]="brief"></textarea>
      </div>
    </div>
    <div class="row mar-lft-rgt-0">
      <div class="col-sm-6 pad-15 text-center">
        <app-material-fileupload [target]="fileUploadUrl" [text]="uploadButtonName" [isMultiple]="false"
                                 (complete)="onFileComplete($event)"></app-material-fileupload>
      </div>
      <div class="col-sm-6 pad-15 text-center upload-msg">{{originalName}}
      </div>
    </div>
    <div class="row mar-lft-rgt-0">
      <div class="col-md-6 pad-15">
        <div class="form-group row">
          <label class="col-sm-4 col-form-label">Requested Date</label>
          <div class="col-sm-8">
            <input [owlDateTimeTrigger]="dt3" [owlDateTime]="dt3" class="form-control radius-0 font-13"
                   [(ngModel)]="rDate">
            <owl-date-time [pickerType]="'calendar'" #dt3></owl-date-time>
          </div>
        </div>

      </div>
      <div class="col-md-6 pad-15">
        <div class="form-group row">
          <label class="col-sm-4 col-form-label">Due Date</label>
          <div class="col-sm-8">
            <input [owlDateTimeTrigger]="dt4" [owlDateTime]="dt4" class="form-control radius-0 font-13"
                   [(ngModel)]="dDate">
            <owl-date-time [pickerType]="'calendar'" #dt4></owl-date-time>
          </div>
        </div>
      </div>
    </div>
<!--    <div class="row mar-lft-rgt-0">-->
<!--      <div class="col-sm-4 pad-15">-->
<!--        <mat-checkbox *ngFor="let action of actions;let i=index;" value="{{action.id}}"-->
<!--                      [(ngModel)]="action.checked"-->
<!--                      (change)="checkAll($event.checked,i)">{{action.action}}</mat-checkbox>-->
<!--      </div>-->
<!--      <div class="col-sm-3 pad-15">-->
<!--        <div class="form-group">-->
<!--          <mat-form-field>-->
<!--            <mat-label>Select Group</mat-label>-->
<!--            <mat-select multiple [(ngModel)]="supportGroupSelected" (selectionChange)="onGroupChange()">-->
<!--              <mat-option *ngFor="let group of groups" [value]="group.id" [disabled]="group.isDisabled">{{group.name}}</mat-option>-->
<!--            </mat-select>-->
<!--          </mat-form-field>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="col-sm-3 pad-15">-->
<!--        <div class="form-group">-->
<!--          <mat-form-field>-->
<!--            <mat-label>Select Users</mat-label>-->
<!--            <mat-select [(ngModel)]="userSelected" (selectionChange)="onUserChange()" multiple>-->
<!--              <mat-option *ngFor="let user of users" [value]="user.id" [disabled]="user.isDisabled">{{user.name}}</mat-option>-->
<!--            </mat-select>-->
<!--          </mat-form-field>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="col-sm-2 pad-15">-->
<!--        <div class="form-group">-->
<!--          <button class="btn btn-primary radius-0 font-13" (click)="addDocu()"> Add </button>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="row mar-lft-rgt-0">
      <table>
        <thead>

        </thead>
      </table>
    </div>
    <div class="row mar-lft-rgt-0">
      <div class="col-sm-6 pad-15">
        <button type="button" class="btn btn-success btn-block radius-0 font-13" (click)="uploadDocu()">Upload
        </button>
      </div>
      <div class="col-sm-6 pad-15">
        <button type="button" class="btn btn-warning btn-block radius-0 font-13" (click)="resetField()">Reset</button>
      </div>
    </div>
  </div>
</div>


<notifier-container></notifier-container>
